import styled from "styled-components";
import { colors } from "globalStyles";

export const Wrapper = styled.div`
  padding: 24px 0;

  h1 {
    font-size: 24px;
    font-weight: bold;
    color: ${colors.DARK_GRAY};
    margin-bottom: 16px;
  }

  .admin-devices__error,
  .admin-devices__empty {
    font-size: 14px;
    font-weight: normal;
    color: ${colors.MEDIUM_GRAY};
    padding: 24px 0;
  }
`;

export const BackLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-bottom: 16px;
  cursor: pointer;
  font-size: 13px;
  color: ${colors.SILKBLUE};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
`;

export const Th = styled.th`
  text-align: left;
  padding: 10px 12px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${colors.MEDIUM_GRAY};
  border-bottom: 1px solid ${colors.LIGHT_GRAY};
`;

export const Td = styled.td`
  padding: 12px;
  color: ${colors.DARK_GRAY};
  border-bottom: 1px solid ${colors.LIGHT_GRAY};
`;

export const Row = styled.tr`
  cursor: pointer;

  &:hover {
    background: ${colors.LIGHT_BLUE};
  }
`;

// Green when the device reports a network type, gray when it doesn't.
export const StatusDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
  background: ${(props) => (props.$online ? colors.STATUS_ONLINE : colors.MEDIUM_GRAY)};
`;

export const Pager = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;

  .admin-devices__page {
    font-size: 13px;
    color: ${colors.MEDIUM_GRAY};
  }
`;

export const PagerButton = styled.button`
  height: 34px;
  padding: 0 14px;
  border: 1px solid ${colors.LIGHT_GRAY};
  border-radius: 6px;
  background: ${colors.WHITE};
  font-size: 13px;
  font-weight: bold;
  color: ${colors.DARK_GRAY};
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DetailLabel = styled.span`
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${colors.MEDIUM_GRAY};
`;

export const FieldValue = styled.div`
  font-size: 15px;
  color: ${colors.DARK_GRAY};
`;
